import { useImageStoreRemote } from "./use-image-store-remote";
export const useImageStore = () => {
  const {
    saveImage,
    getImageUrl,
    duplicatePublicImage,
    getRenderedResultImageURL,
  } = useImageStoreRemote();

  return {
    saveImage,
    getImageUrl,
    duplicatePublicImage,
    getRenderedResultImageURL,
  };
};
